
import type { PropOptions } from 'vue';
import Vue from 'vue';

export type BravadoAvatarItem = {
  image: string;
  name: string;
  title: string;
};

export default Vue.extend({
  name: 'BravadoAvatar',
  props: {
    item: {
      type: Object,
      required: true,
    } as PropOptions<BravadoAvatarItem>,
  },
});
